import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../AuthProvider";

export const ProtectedRoute = ({
  children,
  requiredRoles = [] as string[],
}) => {
  const { roles, loading } = useAuth() as { roles: string[]; loading: boolean };

  if (loading) {
    return <div>Loading...</div>; // Ou un vrai spinner
  }

  const hasAccess = roles.some((role) => requiredRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};
